/**
 * Enum for partner categories.
 * @enum {string}
 */
const Categories = Object.freeze({
    UNIVERSITY: "university",
    RESEARCH_LAB: "research-lab"
});

/**
 * Represents an academic institution.
 * @typedef {Object} academicInstitution
 * @property {string} name - The name of the academic institution.
 * @property {string} tag - The institution tag
 * @property {string} description - A description of the academic institution.
 * @property {boolean} display_description - Whether to display the description.
 * @property {{x: number, y: number}} dot_position - The X-coordinate of the dot.
 * @property {string} category - The category of partnership this institution has
 * @property {Object[]} groups - The militantist groups from the academy
 */

/**
 * @type {AcademicInstitution[]}
 */

export const academicInstitutions = [];

import institutions from '@/country_specific/assets/references/institutions.json';

for (const institution of Object.values(institutions)) {
    if (institution.lat !== "error") {
        academicInstitutions.push(institution);
        console.log(institution)
    } else {
        console.log("Skipping " + institution.tag);
    }
}



/**
 * @param {string} tag
 * @returns {AcademicInstitution | undefined}
 */
export const findInstitutionByTag = (tag) => {
    return academicInstitutions.find(institution => institution.tag === tag);
};


export const findInstitutionByTagAndOffset = (tag, offset) => {
    const idx = academicInstitutions.findLastIndex(institution => institution.tag === tag);
    const newIdx = (idx + offset) % academicInstitutions.length;

    if (newIdx >= 0) {
        return academicInstitutions[newIdx];
    } else {
        return academicInstitutions[academicInstitutions.length + newIdx];
    }
}

/**
 * @param {string} category
 * @returns {AcademicInstitution[]}
 */
export const filterInstitutionsByCategory = (category) => {
    return academicInstitutions.filter(institution => institution.color === Categories[category]);
};

